export default __webpack_public_path__ + "static/media/key.1b402a70.png";